"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAdnamiAd = exports.isNativeAd = exports.isBannerAd = void 0;
function isBannerAd(adObj) {
    return adObj.adType === 'banner' && adObj.source === 'rtb';
}
exports.isBannerAd = isBannerAd;
function isNativeAd(adObj) {
    return adObj && adObj.adType === 'native' && adObj.source === 'rtb';
}
exports.isNativeAd = isNativeAd;
var isAdnamiAd = function (_a) {
    var adType = _a.adType, width = _a.width, height = _a.height;
    return adType === 'banner' && width === 1 && height === 2;
};
exports.isAdnamiAd = isAdnamiAd;
